import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea, Box, Grid, Divider } from "@mui/material";
import PageBanner from "../../../../common/components/PageBanner";
import OurTeamComponentModal from "./ourTeamComponentModal";
import { data } from "../data/TeamComponentData";
import "../styles/Aboutus.css";

// TODO(refresh): set to the supplied Meet the Team header banner.
import TEAM_BANNER from "../../../../assets/new-images/meet_the_team.png";

export default function OurTeamComponent() {


  return (
    <Grid container  sx={{ paddingBottom: "50px" }}>
      <PageBanner
        image={TEAM_BANNER}
        alt="MYREDFOLDER team members walking and talking together outside an office building."
        eyebrow="About Us / Meet the Team"
        title="Meet the Team"
      />
      <div className="our-team-container">
        <Grid container item
      
          xs={12} md={12} sx={{ alignContent: 'center', justifyContent: "center", my:"30px" }}
        >
          <Typography className="primary-font-bold3" sx={{ width: '100%', textAlign: "center" }}>
            Meet the people helping families plan ahead. MYREDFOLDER, Inc. leads the program offering, and NEPTA supports administration and preparedness outreach.
          </Typography>
          </Grid>

          {/* <Grid container spacing={2} item xs={12} md={12} lg={12}> */}
          {/* <Grid item xs={1} md={1} lg={1}></Grid>{" "} */}
          {/* <Grid
          container
          spacing={2}
          // rowGap={"20px"}
          // item
          xs={12}
          md={12}
          justifyContent="center"
        > */}
       
  <Grid     
          container rowSpacing={2} columnSpacing={3} sx={{justifyContent:'start'}}>
          {data.map((item, i) => (
              <Item key={i} item={item} />
            ))}{" "}
</Grid>
         
          {/* </Grid> */}
          {/* <Grid item xs={1} md={1} lg={1}></Grid> */}
          {/* </Grid> */}
        
      </div>
    </Grid>
  );
}
function Item(props) {
  const [open, setOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const handleClose = () => setOpen(false);


  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <Grid item  xs={12} sm={6} md={4} lg={4}  sx={{display:"flex", justifyContent:"start",mx:{xs:"6%",sm:"unset"}}}
    >
      <Card
           onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        sx={{':hover': { boxShadow: 7 }, 
              height:"100%",width:"100%" }}    >
       
          <CardMedia
          component="img"
            image={props.item.profile}
            alt={`Portrait of ${props.item.profileName}`}
            onClick={() => { setOpen(!false) }}
            sx={{ cursor: "pointer",width: '100%',
            objectFit: 'cover', }}
          />
          {/* <img
            
            // className="our-team-image"
            src={props.item.profile}
            alt={`Portrait of ${props.item.profileName}`}
            onClick={() => { setOpen(!false) }}
            style={{ cursor: "pointer",height:"100%",width:"100%" }}/> */}
          <Divider
            sx={{ backgroundColor: isHovered ? "red" : "#0A1821", height: 3 }}
          />
        <CardContent

          >
            <Box component="button" type="button" aria-label={`Read more about ${props.item.profileName}`} sx={{ cursor: "pointer", width: "100%", background: "none", border: 0, p: 0, font: "inherit" }} onClick={() => { setOpen(!false) }}>


              <Typography
                className="our-team-profile-font"
                sx={{ textAlign: "center" }}
              >
                {props.item.profileName}
              </Typography>
              <Typography
                className="primary-font-medium-6 our-team-position"
              >
                {props.item.position}
              </Typography>
            </Box>

          </CardContent>
 
      </Card>
      <OurTeamComponentModal
        onClose={handleClose}
        open={open}
        data={props.item}
      />
    </Grid>
  );
}
